export default __webpack_public_path__ + "static/media/burger.bb2be8bc.svg";